/**
 *
 * @param {string} property
 * @returns {string}
 */
function getMetaContent(property) {
  const tags = document.getElementsByTagName('meta');
  for (let i = 0; i < tags.length; i += 1) {
    const tagProp = tags[i].getAttribute('property');
    if (tagProp === property) {
      return tags[i].getAttribute('content');
    }
  }
  return '';
}

export default getMetaContent;
